import React, { useState, useEffect } from 'react'

import { NavLink } from 'react-router-dom';

import {
  Container,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  Button
} from 'reactstrap';

import { HeadLogo } from '@assets';

export default function NavBar() {

  const [isOpen, setIsOpen] = useState(false);
  const [scroll, setScroll] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  useEffect(() => {

    const handleScroll = () => {
      setScroll(window.scrollY > 50);
    }

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll)
    };
  }, []);

  return (
    <>
      <Navbar dark expand="lg" fixed="top" className={scroll ? "nav-black" : ""}>
        <Container className="py-lg-2">
          {/* <NavbarBrand href='/'> */}
            <NavLink to="/">
              <img src={HeadLogo} alt="Logo" className="img-fluid" style={{ width: '195px' }} />
            </NavLink>
          {/* </NavbarBrand> */}

          <NavbarToggler onClick={toggle} />
          <Collapse isOpen={isOpen} navbar>
            <Nav className="ml-auto" navbar>
              {/* <NavItem>
                <NavLink to="/new" className="">New Home</NavLink>
              </NavItem> */}
              <NavItem>
                <NavLink to="/home-old" className="">Home</NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/pricing-old" className="">Pricing</NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/features-old" className="">Features</NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/contact-us" className="">Contact us</NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink to="/about-us" className="">About us</NavLink>
              </NavItem> */}
            </Nav>

            <Nav className="ml-auto d-flex align-items-center" navbar>
              {localStorage.getItem("auth_token") !== null ?
                <>
                <NavItem>
                  <NavLink to="/logout">Logout</NavLink>
                </NavItem>
                <NavLink to="/login"><Button color="green">Go to App</Button></NavLink>
                </>
              : <>
                <NavItem>
                  <NavLink to="/login">Login</NavLink>
                </NavItem>
                <NavLink to="/signup"><Button color="green">Try for Free</Button></NavLink>
                </>
              }
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  )
}
